import { render, staticRenderFns } from "./ManageBranches.vue?vue&type=template&id=986db82c&scoped=true"
import script from "./ManageBranches.vue?vue&type=script&lang=js"
export * from "./ManageBranches.vue?vue&type=script&lang=js"
import style0 from "./ManageBranches.vue?vue&type=style&index=0&id=986db82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986db82c",
  null
  
)

export default component.exports